export default __webpack_public_path__ + "static/media/popAd4.4cf08aaa.gif";